import { render, staticRenderFns } from "./PerformancePhase.vue?vue&type=template&id=23d62af2&scoped=true&"
import script from "./PerformancePhase.vue?vue&type=script&lang=js&"
export * from "./PerformancePhase.vue?vue&type=script&lang=js&"
import style0 from "./PerformancePhase.vue?vue&type=style&index=0&id=23d62af2&lang=stylus&scoped=true&"
import style1 from "./PerformancePhase.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d62af2",
  null
  
)

export default component.exports